// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__yhRJt","label":"Labeled_label__2oxoN","divider":"Labeled_divider__1HVYw"};